<template>
  <permission-gate
    moduleKey="cilindros"
    :showNoEditAlert="true"
  >
    <template #default="{ canEdit }">
      <main-breadcrumb
        :items="items"
        showBackButton
      ></main-breadcrumb>
      <main-buttons-bar :align="'space-between'">
        <template #left>
          <custom-title>Detalle de cilindro</custom-title>
        </template>
      </main-buttons-bar>
      <detail-container>
        <el-form
          ref="formRef"
          :model="cylinder"
          :rules="formRules"
          size="default"
        >
          <div class="detail-container">
            <el-row :gutter="24">
              <custom-select
                v-model="cylinder.CilindroTipo"
                :label="'Tipo cilindro'"
                :spanColumn="4"
                :settings="{
                  placeholder: 'Seleccionar cilindro',
                  disabled: true,
                  options: cilindroTipoList,
                }"
                @update:modelValue="handleTipoCilindroChange"
              >
              </custom-select>
              <el-form-item>
                <custom-input-number
                  v-model="cylinder.CantidadMagneticos"
                  :label="'Cantidad de magneticos'"
                  :settings="{
                    placeholder: 'Cantidad de magneticos',
                    inputClass: 'ancho_total',
                    min: 0,
                    precision: 0,
                    step: 0.01,
                    controls: false,
                  }"
                ></custom-input-number>
              </el-form-item>
              <el-form-item prop="CantidadCilindros">
                <custom-input-number
                  v-model="cylinder.CantidadCilindros"
                  :label="'Cantidad de cilindros'"
                  :settings="{
                    placeholder: 'Cantidad de cilindros',
                    min: 0,
                    precision: 0,
                    step: 0.01,
                    controls: false,
                  }"
                ></custom-input-number>
              </el-form-item>
              <el-form-item>
                <custom-input-number
                  v-model="cylinder.CantidadAlmasStamping"
                  :label="'Cantidad de almas de stamping'"
                  :settings="{
                    placeholder: 'Cantidad de almas de stamping',
                    inputClass: 'ancho_total',
                    min: 0,
                    precision: 0,
                    step: 0.01,
                    controls: false,
                  }"
                ></custom-input-number>
              </el-form-item>
              <el-form-item>
                <custom-input-number
                  v-model="cylinder.CantidadCilindrosRelieveEnLinea"
                  :label="'Cantidad de cilindros de relieve en línea'"
                  :settings="{
                    placeholder: 'Cantidad de cilindros de relieve en línea',
                    inputClass: 'ancho_total',
                    min: 0,
                    precision: 0,
                    step: 0.01,
                    controls: false,
                  }"
                ></custom-input-number>
              </el-form-item>
              <el-col :span="4">
                <div class="custom-label">Activo</div>
                <el-switch
                  v-model="cylinder.Activo"
                  active-text="Si"
                  inactive-text="No"
                  class="mb-2"
                  sieze="large"
                />
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="3">
                <div class="custom-label">Engranaje</div>
                <el-select
                  v-model="cylinder.Desarrollo.Engranaje"
                  disabled
                  style="width: 100%"
                  size="default"
                  clearable
                  filterable
                  remote
                  :fetch-suggestions="fetchEngranaje"
                  :loading="isLoading"
                  placeholder="Seleccionar engranaje"
                  @update:modelValue="handleEnganajeChange"
                >
                  <el-option
                    v-for="desarrollo in desarrollos"
                    :key="desarrollo.Engranaje"
                    :label="desarrollo.Engranaje"
                    :value="desarrollo.Engranaje"
                  />
                </el-select>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-descriptions
                  size="default"
                  title="Detalles del Cilindro"
                  border
                >
                  <el-descriptions-item label="Engranaje">{{
                    cylinder.Desarrollo.Engranaje
                  }}</el-descriptions-item>
                  <el-descriptions-item label="Paso">{{
                    cylinder.Desarrollo.Paso
                  }}</el-descriptions-item>
                  <el-descriptions-item label="Desarrollo">{{
                    cylinder.Desarrollo.Desarrollo
                  }}</el-descriptions-item>
                </el-descriptions>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <div
          v-if="canEdit"
          class="container"
        >
          <custom-confirm-buttons
            :disabled="false"
            :showLoading="false"
            :confirmText="'Guardar'"
            :cancelText="'Cancelar'"
            @on-cancel="onCancel"
            @on-confirm="onConfirm"
          ></custom-confirm-buttons>
        </div>
      </detail-container>
    </template>
  </permission-gate>
</template>

<script setup>
import {
  ref,
  reactive,
  onBeforeMount,
  computed,
} from 'vue';
import { storeToRefs } from 'pinia';
import CustomConfirmButtons from '@/shared/components/custom_confirm_buttons.vue';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';
import CustomSelect from '@/shared/components/custom_select.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import DetailContainer from '@/shared/layout/detail/detail_container.vue';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import { useCilindroTipoStore } from '@/stores/cilindro-tipo/cilindro-tipo';
import { useCylinderStore } from '../stores/cylinders_store.js';
import { useDesarrolloStore } from '@/stores/desarrollo/desarrollo_store.js';
import { useMessageError } from '@/shared/composables/message_error.js';
import { useMessageSuccess } from '@/shared/composables/message_success.js';
import { useLoading } from '@/shared/composables/loading.js';
import { ElNotification } from 'element-plus';
import {
  useRoute,
  useRouter,
} from 'vue-router';
import { Desarrollo } from '../models/cylinder_model.js';
import PermissionGate from '@/shared/components/permission_gate.vue';

const cilindroTipoStore = useCilindroTipoStore();
const cylinderStore = useCylinderStore();
const desarrolloStore = useDesarrolloStore();
const route = useRoute();
const router = useRouter();
const { firstCilindroTipo } = cilindroTipoStore;
const { cilindroTipoList } = storeToRefs(cilindroTipoStore);
const { findOneDesarrolloCilindroTipoHTTP, resetCilindros, updateCylinderHTTP } = cylinderStore;
const { findAllDesarrollos, searchDesarrolloHTTP } = desarrolloStore;
const { cylinder } = storeToRefs(cylinderStore);
const { desarrollos } = storeToRefs(desarrolloStore);

const isLoading = ref(false);
const fetchEngranaje = async (query, cb) => {
  let results = [];
  isLoading.value = true;
  if (query && query.length >= 1 && query !== 'null') {
    results = await searchDesarrolloHTTP(query);
    isLoading.value = false;
    cb(results);
  } else {
    cb([]); //  devolver una lista vacía si no hay consulta
  }
};
const items = [
  { label: 'Inicio', to: '/page/cylinders/list', replace: false },
  { label: 'Edit', to: null, replace: false },
];
const formRef = ref(null);

const formRules = reactive({
  CantidadCilindros: [
    { required: true, message: 'Ingresar cantidad cilindros', trigger: 'change' },
  ],
});

function handleTipoCilindroChange(item) {
  cylinder.value.CodigoCilindroTipo = item.Codigo;
}
async function handleEnganajeChange(item) {
  if (item) {
    const engranaje = await searchDesarrolloHTTP(item);
    cylinder.value.Desarrollo = engranaje[0];
  } else {
    cylinder.value.Desarrollo = { ...Desarrollo };
  }
}

const emit = defineEmits(['closed']);

const onCancel = () => {
  resetCilindros();
  resetFormValidation();
  router.push('/page/cylinders/list');
};

onBeforeMount(() => {
  firstCilindroTipo();
  findAllDesarrollos();
  const CodigoCilindroTipo = route.params.CodigoCilindroTipo;
  const CodigoDesarrollo = route.params.CodigoDesarrollo;
  if (CodigoCilindroTipo && +CodigoCilindroTipo > 0 && CodigoDesarrollo && +CodigoDesarrollo > 0) {
    findOneDesarrolloCilindroTipoHTTP(CodigoCilindroTipo, CodigoDesarrollo);
  }
});

const resetFormValidation = () => {
  if (formRef.value) {
    formRef.value.resetFields();
  }
};

const onConfirm = async () => {
  formRef.value.validate(async (valid) => {
    if (valid) {
      try {
        useLoading().openLoading();
        await updateCylinderHTTP();
        useMessageSuccess().open(`Los datos se han actualizado existosamente!`);
        router.go(-1);
      } catch (err) {
        useMessageError().open(`Ha ocurrido un error al intentar actualizar los datos.`);
      } finally {
        useLoading().closeLoading();
      }
    } else {
      ElNotification({
        title: 'Cilindros',
        message: 'Por favor, revise los campos ingresados.',
        type: 'warning',
      });
    }
  });
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  margin: 5%;
}

.el-form {
  margin-top: 0;
}

/* Elimina los márgenes de los el-form-item */
.el-form-item {
  margin-top: 0;
  margin-bottom: 0;
}

.input-margin {
  margin-top: 3%;
}

.full-width {
  width: 100%;
}

.custom-label {
  font-weight: 700;
  color: #111;
}

.container {
  display: flex;
  justify-content: flex-end;
  /* Alinea todo el contenido al final del contenedor */
}
</style>
